module.exports = __webpack_public_path__ + "8955291947a592d191fdcf9b7c5ffca8.png";